<template>
  <div class="about">
    <div class="top flex flex-col justify-between">
      <div class="mt-8 nav-bar">
        <div class="van-nav-bar__left" v-if="!isWechat()">
          <img src="../assets/images/back.svg" alt="" @click="goHomePage">
        </div>
        <div class="mx-auto">
          <span class="text-white">{{ $t('about.title') }}</span>
        </div>
      </div>
      <div class="bg-black text-white p-4 m-4 rounded-md">
        <h1 class="text-lg"><img class="inline-block mb-1 mr-2" src="../assets/images/point.svg" alt="">
          {{ $t('about.tickets') }}
          <span class="text-xs float-right text-white-700" @click="showDialogRules = true">{{ $t('about.rules') }}</span></h1>
        <h3 class="text-4xl">{{ userInfo.tickets }}</h3>
        <p class="text-xs text-white-700" v-if="userInfo.expire_item">
          {{ $t('about.expire_prompt', { num: userInfo.expire_item.balance, date: formatDate(userInfo.expire_item.expired_at) }) }}
          <img class="inline-block" src="../assets/images/info-circle.svg" alt=""></p>
      </div>
    </div>
    <van-tabs v-if="userInfo.id" v-model="activeName" class="tabs-list">
      <van-tab :title="$t('about.income')" name="have_got">
        <van-list
            class="van-clearfix"
            v-model="loadingGot"
            :finished="finishGot"
            :finished-text="$t('about.no_more')"
            @load="loadGot">
          <van-cell v-for="item in listGot" :key="item.id" :title="getGotTitle(item)" :label="item.created_at"
                    :value="getCreditValue('+', item.amount)"/>
        </van-list>
      </van-tab>
      <van-tab :title="$t('about.expenditure')" name="have_used">
        <van-list
            class="van-clearfix"
            v-model="loadingUsed"
            :finished="finishUsed"
            :finished-text="$t('about.no_more')"
            @load="loadUsed">
          <van-cell v-for="item in listUsed" :key="item.id" :label="item.created_at"
                    title-class="truncate"
                    :value="getCreditValue('-', item.cost)">
            <template #title>
              <span>{{getUsedTitle(item)}}</span>
            </template>
          </van-cell>
        </van-list>
      </van-tab>
    </van-tabs>

    <bud-dialog :showDialog="showDialogRules" @close-dialog="showDialogRules = false" class="p-6 text-center">
      <p>{{ $t('about.rules_detail') }}</p>
    </bud-dialog>
  </div>
</template>

<script>
import {isWechat} from '@/helpers/utils'
import BudDialog from '../components/BudDialog'
import _ from 'lodash'

export default {
  components: {
    BudDialog
  },
  data() {
    return {
      userInfo: {},
      // 已获得列表
      listGot: [],
      listGotQuery: {
        page: 1,
      },
      // 已使用列表
      listUsed: [],
      listUsedQuery: {
        page: 1,
      },
      loadingUsed: false,
      finishUsed: false,

      loadingGot: false,
      finishGot: false,
      activeName: 'have_got',
      showDialogRules: false
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (!this.userInfo) {
      this.getUserCredit();
    } else {
      this.queryUserTickets(this.userInfo);
    }
  },
  methods: {
    isWechat,
    getUserCredit() {
      const user_id = new URLSearchParams(window.location.search).get('user_id') || localStorage.getItem('user_id');
      localStorage.setItem('user_id', user_id);
      this.userInfo = JSON.parse(localStorage.getItem('userInfo') || JSON.stringify({tickets: 0}));
      // 拿token
      this.$http
        .post('user/signin_by_id', {user_id: user_id})
        .then((res) => {
          localStorage.setItem('Authorization', res.data.token);
          // 获取积分和中奖信息
          this.queryUserTickets(res.data.user);
        });
    },
    queryUserTickets(user = {}) {
      this.$http.get('game/tickets/query')
        .then(result => {
          const userInfo = Object.assign(
            user,
            {tickets: result.data.tickets},
            {expire_item: result.data.expire_item}
          );
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.userInfo = userInfo;
        })
    },
    getCreditValue(type, value) {
      return type + value;
    },
    getGotTitle(item) {

        const game = this.$i18n.locale === 'en' ? (item.game?item.game.en_name:'') : (item.game?item.game.name:'');
        const tournament = this.$i18n.locale === 'en' ? item.en_origin: item.origin;
        switch (item.type) {
          case 0:
            return this.$t('about.game_get_tickets', { game });
          case 1: {
            const rankType = ['history', 'month', 'week'][_.get(item, 'period.type', 0)];
            return this.$t(`about.${rankType}_rank_get_tickets`, { game });
          }
          case 4:
          case 5:
            return tournament;

          default:
            return this.$t('about.default_get_tickets');
        }

    },
    getUsedTitle(item) {
      switch (item.type) {
        case 0:
          return this.$t('about.cost_ticket', { name: this.getGoodsName(item.goods) });
        case 1:
          return this.$t('about.lucky_draw');
        default:
          return this.$t('about.cost_ticket');
      }

    },
    getGoodsName(goods) {
      return goods.map(i => {
        const name = i.goods_name + ' ' + (i.spec || '')
        const en_name = i.en_name + ' ' + (i.en_spec || '')
        return this.$i18n.locale === 'en' ? en_name : name;
      }).join(';');
    },
    loadUsed() {
      this.$http.get('game/tickets/records', {
        params: {page: this.listUsedQuery.page++}
      })
          .then(result => {
            if (result.data && result.data.list && result.data.list.length) {
              this.listUsed.push(...result.data.list);
              this.loadingUsed = false;
            } else {
              this.loadingUsed = false;
              this.finishUsed = true;
            }
          })
    },
    loadGot() {
      this.$http.get('game/tickets/list', {
        params: {page: this.listGotQuery.page++}
      })
          .then(result => {
            if (result.data && result.data.list && result.data.list.length) {
              this.listGot.push(...result.data.list);
              this.loadingGot = false;
            } else {
              this.loadingGot = false;
              this.finishGot = true;
            }
          });
    },
    goHomePage() {
      this.$router.push('/');
    },
    onClickBack() {
      this.$router.back();
    },
  },
}
</script>

<style lang="scss">
.about {
  background: url("../assets/images/bg-mypoint.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100%;
  background-color: #1B1C1E;
  .top {
    height: 245px;
  }
}
.nav-bar {
  position: relative;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  line-height: 1.5;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
}

.van-tabs__wrap {
  background-color: #1B1C1E;
  height: 55px !important;
}

.van-tabs__line {
  background-color: theme('colors.main') !important;
}

.tabs-list {
  height: calc(100vh - 245px);
  //position: absolute;
  //left: 0;
  //right: 0;
  //bottom: 0;
  //overflow: auto;
  //-webkit-overflow-scrolling: touch;
  background-color: #000;
  .van-tabs__nav--line {
    padding-bottom: 5px;
  }

  .van-tabs__nav {
    background-color: #1B1C1E;

    .van-tab {
      color: #fff;

      &.van-tab--active {
        color: #fff;
      }
    }
  }

  .van-cell:nth-child(odd) {
    background-color: #000;
  }

  .van-cell:nth-child(even) {
    background-color: #1B1C1E;
  }

  .van-cell__title {
    color: #fff;
    flex-grow: 3;
  }

  .van-cell__value {
    span {
      position: relative;
      top: 10px;
      font-size: 14px;
      color: theme('colors.main');
    }
  }

  .van-cell::after {
    border: none;
  }
}

.van-list__finished-text {
  //background-color: #1B1C1E;
}


</style>
